import React from "react";
import { connect } from "react-redux";
import { ingestionActions } from "../../actions";

function ClassifyDeal(props) {
  const {
    dealjacket_id,
    ingestion,
    toggleClassify,
    handleClassify,
  } = props;
  const classifications = ingestion.classifications;
  const isClassifying = ingestion.isClassifying;

  const spinner = require("../../images/spinner.gif");

  function buildReport(pages) {
    if (pages === null) {
      return "A problem was encountered during classification.";
    }
    let numLowConf = 0;

    pages.forEach(function (page) {
      if (page.confidence < 1) {
        numLowConf++;
      }
    });

    let report = "";

    if (numLowConf === 0) {
      report = "No issues detected in classification.";
    } else {
      report = numLowConf + " pages were classified with low confidence.";
    }

    return report;
  }

  return (
    <div className="classifyDeal">
      <div className="classifyForm">
        {isClassifying && (
          <table class="classifyFormTable">
            <tbody>
            <tr>
              <td colSpan="2">
                <h3>classifying...</h3>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <img src={spinner} alt="spinner" />
              </td>
            </tr>
            </tbody>
          </table>
        )}
        {!isClassifying &&
          (!classifications ||
            Number(dealjacket_id) !==
              Number(classifications.deal_jacket_id)) && (
            <table className="classifyFormTable">
              <tbody>
              <tr>
                <td colSpan="2">
                  <h3>Classify Deal Jacket</h3>
                </td>
              </tr>
              <tr colSpan="2">
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td colSpan="2">
                  <hr />
                </td>
              </tr>
              <tr colSpan="2">
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td className="formLabel">
                  <label htmlFor="limit">Select algorithm:</label>
                </td>
                <td className="formInfo">
                  <select defaultValue="Maxent">
                    <option value="Naive Bayes">Naive Bayes</option>
                    <option value="Maxent">Maximum Entropy</option>
                  </select>
                </td>
              </tr>
              <tr colSpan="2">
                <td>&nbsp;</td>
              </tr>
              <tr colSpan="2">
                <td>&nbsp;</td>
              </tr>
              <tr colSpan="2">
                <td colSpan="2" align="center">
                  <span
                    id="classify"
                    className="classifyFormButton"
                    name="classify"
                    onClick={handleClassify}
                  >
                    Classify
                  </span>
                  <span
                    id="cancel"
                    className="classifyFormButton"
                    name="cancel"
                    onClick={toggleClassify}
                  >
                    Cancel
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          )}
        {!isClassifying &&
          classifications &&
          Number(dealjacket_id) === Number(classifications.deal_jacket_id) && (
            <table className="classifyFormTable">
              <tr>
                <td colSpan="2">
                  <h3>Classification Success!</h3>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <hr />
                </td>
              </tr>
              <tr>
                <td colSpan="2">classification report:</td>
              </tr>
              <tr colSpan="2">
                <td>
                  {classifications?.pages && buildReport(classifications.pages)}
                </td>
              </tr>
              <tr colSpan="2">
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td align="center" colSpan="2">
                  <span
                    id="close"
                    className="classifyFormButton"
                    name="close"
                    onClick={toggleClassify}
                  >
                    Close
                  </span>
                </td>
              </tr>
            </table>
          )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const { ingestion } = state;
  return {
    ingestion,
  };
}

const actionCreators = {
  classifyDealJacket: ingestionActions.classifyDealJacket,
};

const connectedClassifyDeal = connect(
  mapStateToProps,
  actionCreators
)(ClassifyDeal);
export { connectedClassifyDeal as ClassifyDeal };
